export const AuthType = {
  Lca: 'lca',
  WebAttestation: 'webAttestation',
  None: 'none',
} as const;
export type AuthType = (typeof AuthType)[keyof typeof AuthType];
